import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppHelper from '../model/AppHelper';
import "./CountdownTimer.css";

export class CountdownTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remainingDuration: props.countDownDuration
    };
  }

  static propTypes = {
    ctrCls: PropTypes.string,
    countDownDuration: PropTypes.number, // in milliseconds
    onCountDownComplete: PropTypes.func,
    countDownCompletedMessage: PropTypes.string
  }

  static defaultProps = {
    ctrCls: "",
    onCountDownComplete: () => {},
    backgroundColor: 'white',
    color: 'black'
  }

  componentDidMount(){
    if(this.props.countDownDuration > 0){
      this.timerId = setTimeout(this.updateCountDown, 1000);
    }
  }

  componentWillUnmount(){
    this.killTimer();
  }

  updateCountDown = () => {
      const newDuration = this.state.remainingDuration - 1000; // Decrement by 1 second
      if (newDuration > 0) {
          this.setState({
              remainingDuration: newDuration
          });
          this.timerId = setTimeout(this.updateCountDown, 1000);
      } else {
          this.setState({
              remainingDuration: 0
          }, function () {
              this.killTimer();
              this.props.onCountDownComplete();
          });
      }
  }

  killTimer = () => {
      if (this.timerId) {
          clearTimeout(this.timerId);
          this.timerId = 0;
      }
  }

  pauseTimer = () => {
    this.killTimer();
  }

  resumeTimer = () => {
    this.timerId = setTimeout(this.updateCountDown, 1000);
  }

  render() {
    const { remainingDuration } = this.state;
    const { countDownDuration, backgroundColor, color, countDownCompletedMessage } = this.props;
    const progress = (countDownDuration - remainingDuration) / (countDownDuration || 1);
    const radius = 26;
    const cirucmference = 2 * Math.PI * radius;
    const strokeWidth = 4;
    const offsetCircumference = countDownDuration === 0 ? 0 : (1 - progress) * cirucmference;
    const boxWidth = (radius * 2) + strokeWidth;
    const formattedTime = AppHelper.formatToTimeString(remainingDuration);
    return (
        <div className="quiz-timer-container" style={{backgroundColor: color}}>
            <svg width={2 * radius} height={2 * radius} viewBox={`0 0 ${boxWidth} ${boxWidth}`}>
                <circle cx={radius + (strokeWidth / 2)} cy={radius + (strokeWidth / 2)} r={radius}
                    fill="none"
                    stroke={backgroundColor} strokeWidth={strokeWidth}
                    strokeDasharray={cirucmference}
                    strokeDashoffset={offsetCircumference}/>
            </svg>
            <span className="formatted-time" style={{color: backgroundColor}}>
                {
                  remainingDuration === 0 ? 
                  (countDownCompletedMessage || formattedTime)  
                  : formattedTime}
            </span>
        </div>
    )
  }
}

export default CountdownTimer